import { imgPath } from "./math_functions.js"

var capitalized_stats = {
    'mobility': 'Mobility',
    'resilience': 'Resilience',
    'recovery': 'Recovery',
    'discipline': 'Discipline',
    'intellect': 'Intellect',
    'strength': 'Strength'
}

export function createTooltipDescriptionRow(img_path, content) // if no img_path send ""
{
//     `
//    <div class='flex_row tooltip_desc_row'>
//        ${img_block}
//        <div class="tooltip_desc_row_text">${content}</div>
//    </div>
//      `

    if (content == "" || content == null)
        return null;

    let row = document.createElement("div");
    row.classList.add("flex_row");
    row.classList.add("tooltip_desc_row");

    if (img_path != '')
    {
        let img = document.createElement("img");
        img.classList.add("icon_40_right_margin");
        img.src = imgPath(img_path);

        row.appendChild(img);
    }

    let text = document.createElement("div");
    text.classList.add("tooltip_desc_row_text");
    text.innerHTML = content;

    row.appendChild(text);

    return row;
}

export function createTooltipRightDescriptionRow(img_path, title, content) // if no img_path send ""
{
//  `<div class='flex_row tooltip_right_desc_row'>
//        ${img_block}
//        <div class="flex_column">
//            <div class="tooltip_right_desc_row_title">${title}</div>
//            <div class="tooltip_desc_row_text">${content}</div>
//        </div>
//    </div>`;

    let row = document.createElement("div");
    row.classList.add("flex_row");
    row.classList.add("tooltip_right_desc_row");

    if (img_path != '')
    {
        let img = document.createElement("img");
        img.classList.add("icon_40_right_margin");
        img.src = imgPath(img_path);

        row.appendChild(img);
    }

    let flex = document.createElement("div");
    flex.classList.add("flex_column");

    let title_ = document.createElement("div");
    title_.classList.add("tooltip_right_desc_row_title");
    title_.textContent = title;

    let text = document.createElement("div");
    text.classList.add("tooltip_desc_row_text");
    text.innerHTML = content;

    row.appendChild(flex);

    flex.appendChild(title_);
    flex.appendChild(text);

    return row;
}

export function createDivider()
{
    let divider = document.createElement('hr');
    divider.classList.add("divider")

    return divider
}

